module.exports = __webpack_public_path__ + "static/media/welcome.18f8d8c3.png";